import React from 'react'
import { useTranslation } from 'react-i18next'
import "./healthPerformance.scss"

function HealthPerformance() {
  const { t } = useTranslation()
  return (
    <div className='container-health-performance'>
      <h1>{t("examples.health_sector.title")}</h1>
    </div>
  )
}

export default HealthPerformance